import React from 'react';
import { useRovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { AISmartButtonRefresh } from '@atlassian/ai-smart-button';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { useConversationAssistantSidebarApi } from '@atlassian/jira-conversation-assistant/src/ui/useConversationAssistantSidebarApi.tsx';

type AiRovoButtonWrapperRefreshProps = Omit<
	React.ComponentProps<typeof AISmartButtonRefresh>,
	'product' | 'cloudId' | 'orgId' | 'isNav4Enabled' | 'sidebarApi' | 'productPage'
>;

export const AiRovoButtonWrapperRefresh = ({
	isDisabled = false,
	getActions = async () => [],
}: AiRovoButtonWrapperRefreshProps) => {
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const { data: rovoEntitlementData } = useRovoEntitlementResource();
	const isNav4Enabled = getWillShowNav4();

	const showRovoButton = rovoEntitlementData?.isRovoLLMEnabled ?? false;

	const sidebarApi = useConversationAssistantSidebarApi({});

	if (!showRovoButton) {
		return null;
	}

	return (
		<AISmartButtonRefresh
			product="jira"
			cloudId={cloudId}
			orgId={orgId}
			isNav4Enabled={isNav4Enabled}
			sidebarApi={sidebarApi}
			productPage="jira"
			isDisabled={isDisabled}
			getActions={getActions}
		/>
	);
};
